import { Typography, Grid,} from '@mui/material'
import React from 'react'

export default function Footer() {

  // const QuickLinks={'Overview': '/Overview',
  //   'Facilities': '/facilities',
  //   'Collection':'/Collections',
  //   'Timings': '/Timings',
  //   'Rules and Regulations': '/Rules',
  //   'Dos and Don\'ts': '/DoNDont',
  //   'Services': '/Services',
  //   'Staff': '/Staffs',
  //   'E-Resources': '/EResources',
  // }
    
  return (
    <Grid container justifyContent={'center'}  sx={{backgroundColor:'secondary.main', p:2, color:'primary.main'}}>
      
      {/* <Grid container spacing={7} justifyContent={'space-evenly'} alignItems={'center'}>

        {/* Image and description 
        <Grid item xs={12} md={3} p={0}  justifyContent={'center'} > 
          <Grid xs={6} md={12}>
            <Box  component={'img'} src={'/imgs/HKBKLogo.png'} sx={{ width: '100%', m: 0, p: 0, alignSelf:'center' }} />
          </Grid>
          <Typography textAlign={'left'}>The HKBKCE Library is a resource centre for teaching, learning & research</Typography>
        </Grid>

        {/* Quick Links 
        <Grid item xs={12} md={6}>
          <Typography variant='h5' textAlign={'left'}>Quick Links</Typography>
          <Divider color='#fff' sx={{mb:2}}/>
          <Grid container spacing={2}> {/* Nested container for two rows 
            {Object.entries(QuickLinks).map(([title, link], index) => (
              <Grid item xs={6} key={title}> {/* Half-width items for two columns 
                <Link to={link} sx={{ textDecoration: 'none', color: 'inherit' }}>
                  <Typography align='left'>{title}</Typography>
                </Link>
              </Grid>
            ))}
          </Grid>
        </Grid>  
        
           
      </Grid> */}

      {/** Trade mark */}
      <Grid item width={1}  >
          {/* <Divider color='#fff' sx={{my:2}} /> */}
          <Typography color={'primary'}>
              ©️ {new Date().getFullYear()} HKBK Group of Institutions
          </Typography>
        </Grid>
    </Grid>
  )
}
